import clsx from 'clsx'

import styles from './Container.module.scss'

const Container = ({
  children,
  className,
  noPadding,
}: {
  children: React.ReactNode
  className?: string
  noPadding?: boolean
}) => (
  <div
    className={clsx(styles.container, className, noPadding && styles.noPadding)}
  >
    {children}
  </div>
)

export default Container
